<template>
  <b-container class="card-container px-0">
    <b-card no-body>
      <template v-slot:header v-if="profile.role === 'admin'">
        <b-row>
          <b-col>
            <b-form-select :options="[{value: null, text: 'All statuses'}, 'training', 'pending', 'processing', 'complete']" v-model="filter_status" class="mr-2" size='sm' style='max-width: 120px' @change="search"/>
            <b-form-select :options="user_options" v-model="filter_user" class="mr-2" size='sm' style='max-width: 200px' @change="search"/>
          </b-col>
          <b-col>
            <b-button size="sm" variant="primary float-right" :to="{name: `${collection}_create`}">Create</b-button>
          </b-col>
        </b-row>
      </template>

      <b-table show-empty :items="items" @row-clicked="view_row" hover class="clickable" :fields="fields">
        <template v-slot:cell(updated)='data'>
          {{data.value | date}}
        </template>
        <template v-slot:cell(created)='data'>
          {{data.value | date}}
        </template>
        <template v-slot:cell(public)='data'>
          <span v-if="data.value"><i class="far fa-check-circle"></i></span>
        </template>
        <template v-slot:cell(tier)='data'>
          <span v-if="data.item.descript_membership && data.item.descript_membership.subscription_status">{{data.item.descript_membership.subscription_status}}</span>
        </template>
        <template v-slot:cell(training_step)='data'>
          <span v-if="data.item.provider !== 'synthesia'">{{data.item.script.reduce((t, {audio_url}) => t + (audio_url ? 1 : 0), 0)}} / {{data.item.script.length}}</span>
          <span v-else>N/A</span>
        </template>
        <template v-slot:cell(status)='data'>
          <b-badge :class='`status-${data.value}`'>{{data.value}}</b-badge>
        </template>
        <!-- <template v-slot:cell(name)='data'>
          <b-link :to="{name: collection, params: {id: data.item.id}}">{{data.value}}</b-link>
        </template> -->
      </b-table>

      <template v-slot:footer>
        <b-form inline>
          <b-button-toolbar>
            <b-button-group size="sm">
              <LoadingButton size="sm" @click="search('previous_page')" :disabled="current_page == 0" :loading="previous_page_loading">&lsaquo; Last</LoadingButton>
            </b-button-group>
            <b-button-group class="ml-2" size="sm">
              <LoadingButton size="sm" @click="search('next_page')" :disabled="items.length != page_size || no_more_results" :loading="next_page_loading">Next &rsaquo;</LoadingButton>
            </b-button-group>
          </b-button-toolbar>

          <b-form-select :options="page_size_options" v-model="page_size" @change="search" size="sm" class='ml-2'></b-form-select>
        </b-form>

      </template>
    </b-card>
  </b-container>
</template>

<script>

import { db } from '@/main.js'
import ItemMixin from '@/mixins/Item.js'
import constants from '@/lib/constants.js'

export default {
  name: 'voice_list',
  metaInfo: {title: 'Clones'},
  mixins: [ItemMixin],
  computed: {
    user_options() {
      let user_options = [{text: 'All users', value: null}]
      for (let user of this.users || []) {
        user_options.push({text: user.email, value: user.id})
      }
      return user_options
    }
  },
  data() {
    let fields = ['name', 'status', 'training_step', 'created', 'updated']

    if (this.profile.role === 'admin') {
      fields.splice(2, 0, 'public')
      fields.splice(2, 0, 'tier')
    }

    return {
      filter_status: null,
      collection: 'voice',
      users: [],
      filter_user: null,
      fields: fields
    }
  },
  created() {
    if (this.profile.role === 'admin') {
      this.$bind('users', db.collection('user').orderBy('created', 'desc'), {maxRefDepth: 0})
    }

    this.search()
  },
  activated () {
    this.search()
  },
  methods: {
    async search(action) {
      this.loading = true

      let query = db.collection(this.collection).where('user', '==', db.collection('user').doc(this.profile.id))
      if (this.profile.team_role.role === constants.team_role.admin || this.profile.team_role.role === constants.team_role.manager) {
        query = db.collection(this.collection).where('team', '==', db.collection('team').doc(this.profile.team.id))
      }

      if (this.profile.role === 'admin') {
        query = db.collection(this.collection)
        if (this.filter_user) {
          query = query.where('user', '==', db.collection('user').doc(this.filter_user))
        }
        if (this.filter_status) {
          query = query.where('status', '==', this.filter_status)
        }
        query = query.orderBy('created', 'desc')
      }

      if (action == 'next_page') {
        this.next_page_loading = true
        let last_item = this.items[this.items.length-1]
        query = query.startAfter(last_item.doc).limit(this.page_size)
        this.current_page++
      } else if (action == 'previous_page') {
        this.previous_page_loading = true
        let first_item = this.items[0]
        query = query.endBefore(first_item.doc).limitToLast(this.page_size)
        this.current_page--
      } else {
        query = query.limit(this.page_size)
        this.current_page = 0
      }

      let docs = await query.get()

      if (docs.docs.length > 0 || action != 'next_page') {
        this.no_more_results = false
        let items = []
        for (let doc of docs.docs) {
          let item = doc.data()

          item.id = doc.id
          item.doc = doc
          items.push(item)
        }

        this.items = items
      } else {
        this.no_more_results = true
        this.current_page--
      }

      if (this.items.length > 0) {
        if (action != 'previous_page') {
          // Peak ahead
          let docs = await query.startAfter(this.items[this.items.length-1].doc).limit(1).get()
          if (docs.docs.length === 0) {
            this.no_more_results = true
          } else {
            this.no_more_results = false
          }
        }
      }

      this.next_page_loading = false
      this.previous_page_loading = false
      this.loading = false
    },
    view_row(item) {
      this.$router.push({name: this.collection, params: {id: item.id, from_item: item}})
    }
  },
}
</script>

<style scoped>

</style>
